<template>
  <div class="zongbao">
    <div class="left">
      <div class="title">配电室列表</div>
      <ul>
        <li
          v-for="(item, index) in leftList"
          :key="index"
          :title="item.roomName"
          :class="leftIndex == index ? 'active' : ''"
          @click="roomClickHandle(index, item.id)"
        >
          <img src="../../assets/images/iconele.png" alt="" />
          <div class="sspan">{{ item.roomName }}</div>
        </li>
      </ul>
    </div>
    <div class="right">
      <div class="title" style="padding-left: 0px">综保配置</div>
      <div class="titleTwo">请勾选有综保的高压设备</div>
      <ul>
        <li v-for="(item, index) in rightList" :key="index">
          <div class="hight-label" @click="jumpEquipment(item, index)">
            <span>{{ item.cabinetNum }}</span>
            <i v-if="!item.hasMaintenance" class="iconfont icon-circle-jf"></i>
            <i v-else class="iconfont icon-dui1-copy-copy"></i>
          </div>
          <el-form
            :label-position="'right'"
            v-if="activeHight === index"
            label-width="90px"
            :model="form"
            :inline="true"
            class="highpressureg-form"
          >
            <input
              class="normal-input"
              :readonly="item.hasMaintenance === 1"
              type="text"
              placeholder="请输入现场编号"
              v-model="form.localeNumber"
              maxlength="15"
              @keyup="form.localeNumber = form.localeNumber.replace(/\s+/g, '')"
            />
            <div class="normal-tag-title" v-if="item.hasMaintenance === 0">
              {{ id }}_
            </div>
            <input
              class="tag-input normal-input"
              :readonly="item.hasMaintenance === 1"
              type="text"
              placeholder="请输入设备编码"
              v-model="form.equipmentCode"
              maxlength="15"
              @keyup="
                form.equipmentCode = form.equipmentCode.replace(/\s+/g, '')
              "
            />
            <div class="icons-box">
              <i
                v-if="!item.hasMaintenance"
                class="iconfont icon-huiche"
                @mousedown="addEquipmentToHighPressure(1)"
              ></i>
              <i
                @mousedown="closeHightPro(item)"
                class="iconfont icon-close"
              ></i>
            </div>
          </el-form>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import {
  Message
} from 'element-ui';
export default {
  data() {
    return {
      id: "",
      leftList: [],
      leftIndex: 0,
      rightList: [],
      Equipment: {},
      form: {
        equipmentCode: "",
        localeNumber: "",
      },
      // 选中的综保信息
      activeHight: "",
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.searchRoomCabinetList();
  },
  methods: {
    searchRoomCabinetList() {
      this.$http
        .post(
          "bma-distribution-service/equipmentCabinet/searchRoomCabinetList",
          {
            projectId: this.id,
          }
        )
        .then((res) => {
          if (res.code == 200) {
            if (res.data) {
              this.leftList = res.data;
              this.leftId = res.data[0].id;
              this.leftIndex = 0;
              this.searchCabinetByHighPressure(res.data[0].id);
            } else {
              this.leftList = [];
            }
          }
        });
    },
    // 提交编辑的信息
    closeHightPro(item) {
      // 如果有值的话，就直接赋值
      if (item.equipmentCode) {
        this.Equipment.hasMaintenanc = 0;
        this.addEquipmentToHighPressure(0);
        this.activeHight = "";
      } else {
        this.activeHight = "";
        this.form.localeNumber = "";
        this.form.equipmentCode = "";
      }
    },
    // 单选综保
    jumpEquipment(item, index) {
      this.Equipment = item;
      this.form.localeNumber = item.localeNumber;
      this.form.equipmentCode = item.equipmentCode;
      this.activeHight = index;
    },
    addEquipmentToHighPressure(flag) {
      console.log(flag);
      console.log(this.form);
      // 操作类型 1.选中添加综保 0.取消删除综保
      if (this.form.localeNumber && this.form.localeNumber) {
        let cabinetId = this.Equipment.id;
        let type = Number(!this.Equipment.hasMaintenance);
        this.$http
          .post(
            "bma-distribution-service/equipment/addEquipmentToHighPressure",
            {
              cabinetId: cabinetId,
              equipmentTypeId: 6,
              equipmentCode:
                flag === 1
                  ? this.id + "_" + this.form.equipmentCode
                  : this.form.equipmentCode,
              localeNumber: this.form.localeNumber,
              type: type,
            }
          )
          .then((res) => {
            if (res.code == 200) {
              Message(res.msg);
              this.Equipment = {};
              this.form.localeNumber = "";
              this.form.equipmentCode = "";
              this.activeHight = "";
              this.searchCabinetByHighPressure();
            }
          });
      } else {
        Message("请将设备编号和综保编号填写完整！");
      }
    },
    // 查询是否含有综保
    searchCabinetByHighPressure() {
      this.$http
        .post(
          "bma-distribution-service/equipment/searchCabinetByHighPressure",
          {
            roomId: this.leftId,
            equipmentTypeId: 6,
          }
        )
        .then((res) => {
          if (res.code == 200) {
            if (res.data) {
              this.rightList = res.data;
            } else {
              this.rightList = [];
            }
          }
        });
    },
    roomClickHandle(index, id) {
      this.activeHight = "";
      this.leftIndex = index;
      this.leftId = id;
      this.searchCabinetByHighPressure();
    },
  },
};
</script>

<style lang="less" scoped>
.zongbao {
  display: flex;
  .title {
    font-size: 14px;
    font-weight: 600;
    color: #152139;
    letter-spacing: 3px;
    margin-bottom: 20px;
    text-align: left;
    padding: 0 20px;
    margin-top: 20px;
  }
  .highpressureg-form {
    margin-top: -42px;
    display: inline-block;
    float: right;
    width: 100%;
    height: 33px;
    margin-right: -305px;
  }
  .left {
    width: 337px;
    height: 849px;
    background: #f8f8f9;
    box-sizing: border-box;
    ul {
      li {
        height: 33px;
        line-height: 33px;
        font-size: 14px;
        color: #152139;
        text-indent: 15px;
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 0 20px;
        &.active {
          font-weight: 600;
          background: rgba(16, 57, 126, 0.1);
        }
      }
      li {
        display: flex;
        align-items: center;
        img {
          width: 20px;
          margin-right: 8px;
        }
        .sspan {
          width: 220px;
          font-size: 14px;
          font-weight: 600;
          text-indent: 0px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .right {
    width: 1278px;
    height: 836px;
    background: #f8f8f9;
    margin-left: 15px;
    padding: 20px;
    box-sizing: border-box;
    .titleTwo {
      font-size: 14px;
      color: #152139;
      margin-bottom: 15px;
    }
    ul {
      // display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      height: 510px;
      overflow: auto;
      li {
        width: 100%;
        position: relative;
        .hight-label {
          width: 290px;
          height: 32px;
          border: 1px solid #e6e6e6;
          cursor: pointer;
          margin-bottom: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 10px;
          box-sizing: border-box;
          margin-right: 25px;
          &:hover {
            background: rgba(234, 236, 241, 0.55);
          }
          &.active {
            background: rgba(234, 236, 241, 0.55);
          }
        }
        i {
          &.icon-circle-jf {
            color: rgba(194, 194, 194, 1);
          }
          &.icon-dui1-copy-copy {
            color: rgba(52, 128, 255, 1);
          }
        }
      }
    }
  }
}
</style>